var _defs, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLansumGroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Group_163260",
    "data-name": "Group 163260",
    width: 226,
    height: 36.18,
    viewBox: "0 0 226 36.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147987",
    "data-name": "Rectangle 147987",
    width: 226,
    height: 36.18,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_84245",
    "data-name": "Path 84245",
    d: "M123.006,2.6l-2.791,7.691-7.451,20.544-2.434,6.7h8.857l2.286-6.39.411-1.143h12.821l2.648,7.533h11.6L136.332,2.6Zm.984,20.841.082-.222L125.5,19.3l.831-2.27,1.916-5.428h.189l1.957,5.527,2.253,6.316Z",
    transform: "translate(-80.339 -1.894)",
    fill: "#1370b2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84246",
    "data-name": "Path 84246",
    d: "M0,2.6V37.538H26.429l2.434-6.7H11.683V2.6Z",
    transform: "translate(0 -1.894)",
    fill: "#1370b2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84247",
    "data-name": "Path 84247",
    d: "M271.161,19.066V13.735h.1l3.231,4.434L287.169,36.1h9.546V.632h-8.273V19.464h-.147l-2.986-3.836-11.064-15H263.661V36.1h7.5Z",
    transform: "translate(-191.991 -0.46)",
    fill: "#1370b2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163258",
    "data-name": "Group 163258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163257",
    "data-name": "Group 163257",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84248",
    "data-name": "Path 84248",
    d: "M421.389,28.87a10.283,10.283,0,0,1-4.863.856q-3.709,0-5.273-1.173t-1.613-4.058H399.334a11.894,11.894,0,0,0,1.83,6.771,10.127,10.127,0,0,0,5.562,3.74,33.617,33.617,0,0,0,9.751,1.173q8.426,0,12.52-2.86t4.093-8.483q0-4.694-2.456-7.236t-7.994-3.422l-8.86-1.418a4.954,4.954,0,0,1-2.528-.978,2.517,2.517,0,0,1-.746-1.956,2.761,2.761,0,0,1,1.324-2.616,8.327,8.327,0,0,1,4.021-.758,9.245,9.245,0,0,1,3.419.513A3.341,3.341,0,0,1,421.076,8.6a6.8,6.8,0,0,1,.554,2.982h10.3q-.145-6.307-4.021-8.947T415.851,0q-7.657,0-11.556,2.86t-3.9,8.434q0,4.743,2.552,7.163t7.7,3.2l8.668,1.271a5.29,5.29,0,0,1,2.793,1.1,2.851,2.851,0,0,1,.771,2.127,2.9,2.9,0,0,1-1.493,2.713",
    transform: "translate(-290.784 0)",
    fill: "#1370b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84249",
    "data-name": "Path 84249",
    d: "M538.825,33.972a13.446,13.446,0,0,0,5.287,2.342,33.807,33.807,0,0,0,7.441.724,27.79,27.79,0,0,0,9.472-1.376,10.628,10.628,0,0,0,5.605-4.394,14.984,14.984,0,0,0,1.86-7.942V1.178h-8.322V22.215a10.517,10.517,0,0,1-.783,4.394,4.8,4.8,0,0,1-2.423,2.438,10.4,10.4,0,0,1-4.283.748,10.72,10.72,0,0,1-4.357-.748,4.775,4.775,0,0,1-2.448-2.462,10.828,10.828,0,0,1-.783-4.466V1.178H534.566v22.2a16.714,16.714,0,0,0,1.077,6.373,10.041,10.041,0,0,0,3.182,4.224",
    transform: "translate(-389.256 -0.858)",
    fill: "#1370b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84250",
    "data-name": "Path 84250",
    d: "M702.7.632l-5.679,16.69-1.86,5.53h-.1l-1.763-5.58L687.722.632h-13.57V36.1h6.766V12.938h.1l1.909,6.377L688.6,36.1h10.182l5.728-16.491,2.056-6.676h.1l-.049,7.174L706.57,36.1H716.9V.632Z",
    transform: "translate(-490.899 -0.46)",
    fill: "#1370b2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLansumGroup);
export default __webpack_public_path__ + "static/media/Lansum Group.704d8bc2b0b1b0115875822ebd672a15.svg";
export { ForwardRef as ReactComponent };